import Main from './Main.html';

Object.assign || ( Object.assign = function assign ( source, ...targets ) {
	targets.forEach( target => {
		if ( !target ) return;
		Object.keys( target ).forEach( key => source[ key ] = target[ key ]);
	});

	return source;
});

const target = document.querySelector( '.interactive-atom .gia' );
target.innerHTML = ''; // TODO hydration

new Main({ target });
